<template>
  <ReportPanel>
    <h6 class="q-mt-md q-mb-xs">
      Select the date range you wish to generate
      the Gambling Support Service (Te Huinga Kōtoku) report for.
    </h6>
    <div class="text-subtitle2 text-grey-7 q-mb-md">
      Both dates are optional &mdash; leave either blank for an
      open-ended range, or both blank to report on all responses.
    </div>

    <strong>Date range</strong>
    <div class="row full-width q-gutter-r-md q-mb-lg items-center">
      <q-input
        v-model="startDate"
        label="After ..."
        stack-label
        type="date"
        bg-color="white"
        outlined
        dense
        class="col-6"
      />

      <q-input
        v-model="endDate"
        label="Before ..."
        stack-label
        type="date"
        dense
        bg-color="white"
        outlined
        class="col-6"
      />
    </div>

    <q-btn
      :loading="loading"
      label="Generate Gambling Report"
      color="secondary"
      no-caps
      class="q-mt-md full-width"
      @click="generateReport"
    />
  </ReportPanel>
</template>

<script>
import api from "@/services/api/api";
import notify from "@/services/util/notify";
import { promptDownload } from "@/services/util/file";
import ReportPanel from "./ReportPanel.vue";

export default {
  name: "GamblingReportPanel",
  components: {
    ReportPanel
  },
  data() {
    return {
      loading: false,
      startDate: null,
      endDate: null
    }
  },
  methods: {
    async generateReport() {
      this.loading = true;

      try {
        const payload = {};
        if (this.startDate) payload.start_date = this.startDate;
        if (this.endDate) payload.end_date = this.endDate;

        const report = await api.reports.generateGambling(payload);
        promptDownload(report, `Gambling Support Report - ${this.getRangeLabel()}.xlsx`);
      } catch (error) {
        console.error(error);
        notify.error("There was an issue generating your Gambling Support report.", "top");
      } finally {
        this.loading = false;
      }
    },

    getRangeLabel() {
      if (this.startDate && this.endDate) return `${this.startDate} to ${this.endDate}`;
      if (this.startDate) return `From ${this.startDate}`;
      if (this.endDate) return `Up to ${this.endDate}`;
      return "All Responses";
    }
  }
}
</script>
